import { CameraData } from "@centricsoftware/model-viewer";
import locale from "csi/locale";
import { routerStore } from "csi/state/rootStore";
import Copy from "csi/table/Copy";
import CameraPositionDialogStore from "csi/threeD/cameraPositions3D/CameraPositionStore";
import NewCameraPositionDialog from "csi/threeD/cameraPositions3D/NewCameraPositionDialog";
import declare from "dojo/_base/declare";

const CopyCameraPosition = declare(Copy, {
	/**
	 * @override
	 * Open React dialog
	 */
	preProcess(): void {
		const {
			$Name: name,
			$URL: url,
			Active: active,
			Description: description,
			Location: location,
			Rotation: rotation,
		  } = this.getNode();

		const cameraData: CameraData = {
			position: location,
			rotation: rotation,
		};

		const existingCameraPositionData = {
			cameraData,
			description,
			name: locale.resource("NAME_COPY", [name]),
			url: null,
			active,
		};

		const onSave = async (jsonResponse: Promise<void>): Promise<void> => {
			this.processReact(jsonResponse);
		};

		const onCancel = (): void => {
			this.onCancelReactDialog();
		};

		const store = new CameraPositionDialogStore(onSave, onCancel, this.m_writer, this, existingCameraPositionData);
		this.useReactDialog(routerStore.openDialog(NewCameraPositionDialog, { store }));
	},
});

export = CopyCameraPosition;